// src/services/authService.js
import { jwtDecode } from 'jwt-decode';
import store from '@/store';
import axios from 'axios';

export function programarRefresh(token) {

    const { exp } = jwtDecode(token); // <- esta línea es la clave
    const tiempoRestante = exp * 1000 - Date.now(); // tiempo en ms
    const tiempoAntesDeExpirar = 60 * 1000; // 1 minuto antes
    
    if (tiempoRestante > tiempoAntesDeExpirar) {
        setTimeout(() => {
            refreshToken(token);
        }, tiempoRestante - tiempoAntesDeExpirar);
    }
}



async function refreshToken(token) {
    try {
        const response = await axios.post('/auth/refresh', null, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        const nuevoToken = response.data.token;
        store.dispatch('setToken', nuevoToken);
        programarRefresh(nuevoToken); // vuelve a programar

    } catch (error) {
        console.error("No se pudo refrescar el token:", error);
        store.dispatch('logout');
    }
}
